import React, { useRef } from 'react'
import { useCopy } from '../../../../shared/clipboard/clipboard'

// A forged request must be refused, never crash the receiver: a missing
// header or t= returns false, and timingSafeEqual (which throws on buffers of
// different lengths) only sees a v1 of the right length.
export const NODE = `const crypto = require('crypto')
// header = req.headers['x-edxr-signature'], body = the raw request body (a string)
const verify = (secret, header, body) => {
  const m = typeof header === 'string' && header.match(/t=(\\d+)/)
  if (!m) return false
  const t = Number(m[1])
  if (Math.abs(Date.now() / 1000 - t) > 300) return false
  const want = Buffer.from(crypto.createHmac('sha256', secret).update(\`\${t}.\${body}\`).digest('hex'))
  return [...header.matchAll(/v1=([0-9a-f]+)/g)].some(v => v[1].length === want.length && crypto.timingSafeEqual(Buffer.from(v[1]), want))
}`

export const PYTHON = `import hmac, hashlib, re, time
# header = request.headers["X-EdXR-Signature"], body = the raw request body (str)
def verify(secret, header, body):
    m = re.search(r"t=(\\d+)", header or "")
    if not m:
        return False
    t = int(m.group(1))
    if abs(time.time() - t) > 300:
        return False
    want = hmac.new(secret.encode(), f"{t}.{body}".encode(), hashlib.sha256).hexdigest()
    return any(hmac.compare_digest(s, want) for s in re.findall(r"v1=([0-9a-f]+)", header))`

// Copy, through the shared helper (shared/clipboard): Copied only after a
// real copy; otherwise the snippet is selected and the shortcut named.
const CopySnippet = ({ label, text, block }) => {
  const copy = useCopy()
  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      <button type="button" className="btn btn-sm sw-btn" onClick={() => copy.copy(text, block)}>{copy.copied ? 'Copied' : `Copy ${label}`}</button>
      {copy.manual && <span className="sw-hint" role="status">{copy.hint}</span>}
    </div>
  )
}

// The receiver's check for X-EdXR-Signature (spec §12.4): hex HMAC-SHA256 of
// "<t>.<raw body>", either v1 during a rotation, t within 5 minutes.
export const VerifySnippet = () => {
  const node = useRef(null)
  const python = useRef(null)
  return (
    <details className="ar-snippet">
      <summary>How to check the signature</summary>
      <p className="sw-hint">Check <code>X-EdXR-Signature</code> before trusting a message. Drop repeats with <code>Idempotency-Key</code>.</p>
      <h3 className="h6">Node</h3><pre className="ar-json" ref={node}>{NODE}</pre>
      <CopySnippet label="Node" text={NODE} block={node} />
      <h3 className="h6">Python</h3><pre className="ar-json" ref={python}>{PYTHON}</pre>
      <CopySnippet label="Python" text={PYTHON} block={python} />
    </details>
  )
}
